module.exports = "button {\r\n    margin: 5px;\r\n}"